import { Button, Text } from "metabase/ui";
import type { UserListResult } from "metabase-types/api";

import Styles from "./UserListElement.module.css";

export type UserListElementProps = {
  value: UserListResult;
  onClick: (value: UserListResult) => void;
  isSelected: boolean;
};

export const UserListElement = ({
  value,
  isSelected,
  onClick,
}: UserListElementProps) => (
  <Button
    data-testid="user-list-element"
    onClick={() => onClick(value)}
    data-is-selected={isSelected}
    px="sm"
    py="xs"
    variant="subtle"
    bg={isSelected ? "core-brand" : undefined}
    // A solid fill was otherwise distinguished only by color (WCAG 1.4.1)
    // — add a real ring so the shape doesn't depend on perceiving the
    // fill's hue.
    style={
      isSelected
        ? {
            outline: "2px solid var(--mb-color-text-primary-inverse)",
            outlineOffset: "-4px",
          }
        : undefined
    }
    justify="start"
    classNames={{
      root: Styles.Root,
    }}
  >
    {/* Was previously the same "core-brand" token as the background above
        — illegible once filled (brand-on-brand). Use the inverse text
        color so it stays readable, matching every other solid-fill
        selected state in the app. */}
    <Text
      fw={700}
      color={isSelected ? "text-primary-inverse" : undefined}
      truncate
    >
      {value.common_name}
    </Text>
  </Button>
);
